import { render, staticRenderFns } from "./StockViewSale.vue?vue&type=template&id=fb169fb0&scoped=true"
import script from "./StockViewSale.vue?vue&type=script&lang=js"
export * from "./StockViewSale.vue?vue&type=script&lang=js"
import style0 from "./StockViewSale.vue?vue&type=style&index=0&id=fb169fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb169fb0",
  null
  
)

export default component.exports